import { render } from "./MaterialUsageTable.vue?vue&type=template&id=9bd3c90a"
import script from "./MaterialUsageTable.vue?vue&type=script&lang=js"
export * from "./MaterialUsageTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
